export default function Logo({ light = false, size = 34 }) {
    return (
        <span className="flex items-center gap-2.5">
            <svg
                width={size}
                height={size}
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <rect width="64" height="64" rx="16" fill="#059669" />
                <path
                    d="M13 21c6.5-3.4 12.5-3.4 19 0v27c-6.5-3.4-12.5-3.4-19 0z"
                    stroke="#ffffff"
                    strokeWidth="3.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M51 21c-6.5-3.4-12.5-3.4-19 0v27c6.5-3.4 12.5-3.4 19 0z"
                    stroke="#A7F3D0"
                    strokeWidth="3.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M47 7l2.4 6.2 6.2 2.4-6.2 2.4L47 24.2l-2.4-6.2-6.2-2.4 6.2-2.4z"
                    fill="#FBBF24"
                />
            </svg>
            <span
                className={`font-display text-lg sm:text-xl font-extrabold tracking-tight ${
                    light ? "text-white" : "text-slate-900"
                }`}
            >
                Drvn <span className="text-emerald-500">Dream</span>
            </span>
        </span>
    );
}
